<template>
  <div>
    <div class="news_title" style="margin-bottom:50px;"> 投诉与咨询服务<span class="iconfont">&#xe70b;</span>投诉咨询</div>
    
    <div class="formBox" style="width:100%;height:100%">
      <!-- 切换表单选项 -->
      <div class="radio" v-show="stateRadio">
        请选择类型：
        <el-radio v-model="radio" label="1">投诉</el-radio>
        <el-radio v-model="radio" label="2">咨询</el-radio>
      </div>
      <!-- 一下是表单的内容 -->
      <tsForm v-show="showtsForm" @aaa="bbb"></tsForm>
      <zxForm v-show="showzxForm" @aaa="bbb"></zxForm>
      <div
        v-show="state2"
        style="width:100%;height:100%;display:flex;flex-direction: column;align-items:center;padding-top:200px;"
      >
        <div style="font-size:36px;">受理成功</div>
        <div>查询单号：{{title}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import tsForm from "@/pages/tszxsevers/ts.vue";
import zxForm from "@/pages/tszxsevers/zixun.vue";
export default {
  name:"complaintsReport",
  data() {
    return {
      state2: false,
      title: "",
      stateRadio: true,
      radio: "1",
      showtsForm: true,
      showzxForm: false
    };
  },
  watch: {
    radio: function() {
      if (this.radio == 2) {
        this.showtsForm = false;
        this.showzxForm = true;
      } else {
        this.showtsForm = true;
        this.showzxForm = false;
      }
    }
  },
  components: {
    tsForm,
    zxForm
  },
  methods: {
    bbb(data) {
      console.log(data);
      if (data[0] == false) {
        this.stateRadio = data[0];
        this.title = data[1];
        this.state2 = true;
      }
    }
  }
};
</script>
<style scoped>
.formBox {
  /* height: 700px; */
  /* border: 1px solid #ccc; */
  padding: 10px;
}
.radio {
  padding-left: 100px;
  /* border:1px solid red; */
  text-align: left;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/tszxsevers/complaintsReport.vue


// WEBPACK FOOTER //
// src/pages/tszxsevers/complaintsReport.vue